class BECFacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : BECFacetFiltersForm.searchParamsInitial;
      conosle.log(searchParams);
      if (searchParams === BECFacetFiltersForm.searchParamsPrev) return;
      BECFacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    BECFacetFiltersForm.searchParamsPrev = searchParams;
    const sections = BECFacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (document.getElementById('CreatorGridContainer')) {
      document.getElementById('CreatorGridContainer').querySelector('.collection').classList.add('loading');
    }
    else {
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    }

    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      // if creatorgrid, url = filter page else
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      BECFacetFiltersForm.filterData.some(filterDataUrl) ?
        BECFacetFiltersForm.renderSectionFromCache(filterDataUrl, event, `${section.sectionType}`) :
        BECFacetFiltersForm.renderSectionFromFetch(url, event, `${section.sectionType}`);
    });

    if (updateURLHash) BECFacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, type) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        BECFacetFiltersForm.filterData = [...BECFacetFiltersForm.filterData, { html, url }];
        BECFacetFiltersForm.renderFilters(html, event);

        if (document.getElementById('CreatorGridContainer')) {
          BECFacetFiltersForm.renderCreatorGridContainer(html);
        }
        else {
          BECFacetFiltersForm.renderProductGridContainer(html);
          // BECFacetFiltersForm.renderProductCount(html);
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event, type) {
    const html = BECFacetFiltersForm.filterData.find(filterDataUrl).html;
    BECFacetFiltersForm.renderFilters(html, event);

    if (document.getElementById('CreatorGridContainer')) {
      BECFacetFiltersForm.renderCreatorGridContainer(html);
    }
    else {
      BECFacetFiltersForm.renderProductGridContainer(html);
      // BECFacetFiltersForm.renderProductCount(html);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderCreatorGridContainer(html) {
    document.getElementById('CreatorGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('CreatorGridContainer').innerHTML;
  }

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  // }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#BECFacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    // BECFacetFiltersForm.renderActiveFacets(parsedHTML);
    // BECFacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) BECFacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  // static renderActiveFacets(html) {
  //   const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

  //   activeFacetElementSelectors.forEach((selector) => {
  //     const activeFacetsElement = html.querySelector(selector);
  //     if (!activeFacetsElement) return;
  //     document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
  //   })

  //   BECFacetFiltersForm.toggleActiveFacets(false);
  // }

  // static renderAdditionalElements(html) {
  //   const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

  //   mobileElementSelectors.forEach((selector) => {
  //     if (!html.querySelector(selector)) return;
  //     document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
  //   });

  //   document.getElementById('BECFacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  // }

  // static renderCounts(source, target) {
  //   const targetElement = target.querySelector('.facets__selected');
  //   const sourceElement = source.querySelector('.facets__selected');

  //   if (sourceElement && targetElement) {
  //     target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
  //   }
  // }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    if (document.getElementById('creator-grid')) {
      return [
        {
          section: document.getElementById('creator-grid').dataset.id,
        }
      ] 
    }
    else {
      return [
        {
          section: document.getElementById('product-grid').dataset.id,
        }
      ]   
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    console.log(formData);
    let searchParams = '';
    if ( event.target.value == 'view_all' ) {
      searchParams = '';
    }
    else {
      searchParams = new URLSearchParams(formData).toString();
    }
    BECFacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    BECFacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    BECFacetFiltersForm.renderPage(url);
  }
}

BECFacetFiltersForm.filterData = [];
BECFacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
BECFacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('bec-facet-filters-form', BECFacetFiltersForm);
BECFacetFiltersForm.setListeners();

// class BECFacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelector('a').addEventListener('click', (event) => {
//       event.preventDefault();
//       const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//       form.onActiveFilterClick(event);
//     });
//   }
// }

// customElements.define('bec-facet-remove', BECFacetRemove);
